var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      ref: "popover",
      attrs: {
        placement: "bottom-end",
        "visible-arrow": false,
        trigger: "manual",
        "popper-class": "tages-popopver",
      },
      on: { "after-leave": _vm.afterLeave },
      model: {
        value: _vm.visiable,
        callback: function ($$v) {
          _vm.visiable = $$v
        },
        expression: "visiable",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isSearch,
              expression: "!isSearch",
            },
          ],
          staticClass: "mulity-menu-wrap",
          style: {
            width: _vm.latestClickedCity ? "640px" : "420px",
            "margin-left": _vm.latestClickedCity ? "-640px" : "-420px",
          },
          on: { click: _vm.handleVisible },
        },
        [
          _c("div", { staticClass: "search-select-options" }, [
            _c("div", { staticClass: "options-wrapper" }, [
              _c(
                "div",
                { staticClass: "menu-tab provice" },
                [
                  _c("div", { staticClass: "hierarchy-name" }, [_vm._v("省")]),
                  _c(
                    "el-scrollbar",
                    {
                      ref: "clickselect",
                      attrs: { "wrap-class": "clickselect-scroll_wrap" },
                    },
                    [
                      _c(
                        "div",
                        { ref: "industryList", staticClass: "menu-list" },
                        _vm._l(
                          _vm.locationOptions.normal,
                          function (province, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "menu-item",
                                class: {
                                  selectedArea:
                                    _vm.isSelectedCity(province, true) ||
                                    province.isChecked,
                                  currentSelect:
                                    province.NUM == _vm.provinceNum,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.clickProvice(province)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    ref: "pro" + province.NUM,
                                    refInFor: true,
                                    attrs: { id: "province" + province.NUM },
                                  },
                                  [
                                    _vm._v(" " + _vm._s(province.NAME) + " "),
                                    _vm.isSelectedCity(province, true)
                                      ? _c("span", [
                                          _vm._v(
                                            "（" +
                                              _vm._s(
                                                _vm.isSelectedCity(
                                                  province,
                                                  true
                                                )
                                              ) +
                                              "）"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "menu-tab city" },
                [
                  _c("div", { staticClass: "hierarchy-name" }, [_vm._v("市")]),
                  _c(
                    "el-scrollbar",
                    {
                      ref: "clickselect",
                      attrs: { "wrap-class": "clickselect-scroll_wrap" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "menu-list area-list" },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "menu-item",
                              class: {
                                selected: _vm.selectedProvice.isChecked,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.clickNode(_vm.selectedProvice)
                                },
                              },
                            },
                            [_vm._v("全部")]
                          ),
                          _vm._l(
                            _vm.selectedProvice.children,
                            function (city, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "menu-item",
                                  class: {
                                    currentSelect:
                                      _vm.latestClickedCity &&
                                      _vm.latestClickedCity.NUM === city.NUM,
                                    selected:
                                      _vm.computeChildrenCount(city) > 0 ||
                                      _vm.isSelectedCity(city),
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickCity(city)
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _vm._v(" " + _vm._s(city.NAME)),
                                    _vm.computeChildrenCount(city) > 0
                                      ? _c("span", [
                                          _vm._v(
                                            "（" +
                                              _vm._s(
                                                _vm.computeChildrenCount(city)
                                              ) +
                                              "）"
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                ]
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm.displayDistrict(_vm.selectedProvice)
                ? _c(
                    "div",
                    { staticClass: "menu-tab district" },
                    [
                      _c("div", { staticClass: "hierarchy-name" }, [
                        _vm._v("区"),
                      ]),
                      _c(
                        "el-scrollbar",
                        {
                          ref: "clickselect",
                          attrs: { "wrap-class": "clickselect-scroll_wrap" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "menu-list area-list" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "menu-item",
                                  class: {
                                    selected: _vm.latestClickedCity.isChecked,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickNode(
                                        _vm.latestClickedCity,
                                        true
                                      )
                                    },
                                  },
                                },
                                [_vm._v("全部")]
                              ),
                              _vm._l(
                                _vm.latestClickedCity.children,
                                function (district, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "menu-item",
                                      class: [{ selected: district.isChecked }],
                                      on: {
                                        click: function ($event) {
                                          return _vm.clickNode(district, true)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " + _vm._s(district.NAME) + " "
                                        ),
                                      ]),
                                    ]
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isSearch,
              expression: "isSearch",
            },
          ],
          staticClass: "mulity-menu-wrap mulity-menu-search",
          on: { click: _vm.handleVisible },
        },
        [
          _c(
            "div",
            { staticClass: "menu-tab flex-box" },
            [
              _c(
                "el-scrollbar",
                {
                  ref: "clickselect",
                  attrs: { "wrap-class": "clickselect-scroll_wrap" },
                },
                [
                  _c("div", { staticClass: "suggestion-text" }, [
                    _vm._v(" 搜索结果： "),
                  ]),
                  _c(
                    "div",
                    { staticClass: "menu-list" },
                    [
                      _vm.searchIndustry.length == 0
                        ? _c("div", { staticClass: "no-data" }, [
                            _c("span", [_vm._v("未找到匹配的结果")]),
                          ])
                        : _vm._l(_vm.searchIndustry, function (item) {
                            return _c(
                              "div",
                              {
                                key: item.code,
                                staticClass: "menu-item",
                                class: {
                                  selected:
                                    _vm.selectedCode.indexOf(item.code) != -1,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.doSelect(item)
                                  },
                                },
                              },
                              [
                                _c("div", {
                                  staticClass: "menu-item-name",
                                  domProps: {
                                    innerHTML: _vm._s(item.showText),
                                  },
                                }),
                              ]
                            )
                          }),
                    ],
                    2
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        {
          class: [
            "search-select-wrap",
            _vm.error.length > 0 ? "error-border" : "",
          ],
          attrs: { slot: "reference" },
          slot: "reference",
        },
        [
          _c(
            "div",
            { staticClass: "select-tag", class: { emptyError: _vm.error } },
            [
              _vm._l(_vm.selectedList, function (item) {
                return [
                  _c(
                    "span",
                    {
                      key: item.code,
                      staticClass: "tag-item",
                      class: { activated: item.isActivated },
                    },
                    [
                      _vm._v(" " + _vm._s(_vm.displayTag(item)) + " "),
                      _c("span", {
                        staticClass: "clear-icon el-icon-close",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.setChecked(item, false)
                          },
                        },
                      }),
                    ]
                  ),
                ]
              }),
            ],
            2
          ),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model.lazy",
                value: _vm.searchKeyWord,
                expression: "searchKeyWord",
                modifiers: { lazy: true },
              },
            ],
            ref: "menuInputFocus",
            staticClass: "tag-search",
            class: { focus: _vm.isFocus },
            attrs: {
              type: "text",
              placeholder:
                _vm.searchKeyWord || _vm.selectedList.length > 0
                  ? ""
                  : _vm.placeholder,
            },
            domProps: { value: _vm.searchKeyWord },
            on: {
              input: _vm.searchQueryString,
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k(
                    $event.keyCode,
                    "backspace",
                    undefined,
                    $event.key,
                    undefined
                  )
                ) {
                  return null
                }
                return _vm.removeKeyEnter.apply(null, arguments)
              },
              focus: _vm.handleFocus,
              blur: _vm.onBlur,
              compositionstart: function ($event) {
                _vm.hasValue = false
              },
              compositionend: function ($event) {
                _vm.hasValue = true
              },
              change: function ($event) {
                _vm.searchKeyWord = $event.target.value
              },
            },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }